import { FC } from 'react';
import {
  Header,
  Title,
  IconWrapper,
  Container,
  Content,
  RightButton,
} from 'components/CustomBloc/style';

interface CustomBlocProps {
  title: string;
  icon: JSX.Element;
  marginLeft?: boolean;
  rightButton?: JSX.Element;
}

const CustomBloc: FC<CustomBlocProps> = ({
  title,
  icon,
  children,
  marginLeft,
  rightButton,
}) => {
  return (
    <Container elevation={1} marginLeft={marginLeft}>
      <Header>
        <IconWrapper>{icon}</IconWrapper>
        <Title>{title}</Title>
        {rightButton && <RightButton>{rightButton}</RightButton>}
      </Header>
      <Content>{children}</Content>
    </Container>
  );
};

export default CustomBloc;
